import { ResourceLanguage } from 'i18next';
import { TranslationExtensionInterface } from '../../../../extension/interface/translation.extension.interface';

/**
 * Benefit-agnostic receipt copy shared across all 5 receipt-rendering benefits, provided via
 * TranslationExtensionInterface (see BikeleasingTranslationExtension) instead of de.json.
 * Resolved via receiptStatusKeys/receiptBenefitKeys in ../receiptTranslation.ts under the
 * `extensions` i18next namespace, moduleName `receipt`.
 */
export class ReceiptTranslationExtension extends TranslationExtensionInterface {
  moduleName = 'receipt';

  get translations(): ResourceLanguage {
    return {
      receipts: {
        APPROVED: {
          title: 'Beleg freigegeben',
          description: 'werden ausbezahlt',
          alertDescription: 'Dein Beleg wurde erfolgreich geprüft',
          modifiedByAuditAlertDescription:
            '$t(extensions:receipt.receipts.APPROVED.alertDescription) - Wir haben den korrekten erstattungsfähigen Betrag für Dich berechnet',
        },
        REJECTED: {
          title: 'Beleg abgelehnt',
          description: 'werden nicht ausbezahlt',
          alertDescription: 'Beleg {{byTenant}} abgelehnt - {{reason}}',
        },
        PENDING: {
          title: 'Beleg in Prüfung',
          description: '',
          alertDescription: 'Dein Beleg befindet sich aktuell in Prüfung',
        },
        WAITING_FOR_AUDIT: {
          title: 'Beleg in Prüfung',
          description: '',
          alertDescription: 'Dein Beleg befindet sich aktuell in Prüfung',
        },
      },
      noReceipt: 'Keine Belege vorhanden.',
      noPeriod: 'Lade jetzt über das + Deinen ersten Beleg hoch!',
      defaultRejectionReason: 'Keine Begründung',
      auditedByTenant: 'vom Arbeitgeber',
      editReceipt: 'Beleg bearbeiten',
      updateReceiptSuccess: 'Beleg wurde aktualisiert',
      noChanges: 'Es wurden keine Änderungen durchgeführt',
      receiptNotEditable: 'Bereits freigegebene Belege können nicht bearbeitet werden.',
      cameraModalTitle: 'Beleg hinzufügen',
      receiptsTitle: 'Belege',
      receiptAlreadyExists: 'Es wurde bereits ein Beleg hochgeladen',
      receiptPicture: 'Foto des Belegs',
      selectPicture: 'Neues Bild auswählen',
      detailPage: {
        title: 'Belegdetails',
      },
      field: {
        refund: 'Auszahlung',
        date: 'Datum',
        comment: 'Kommentar',
      },
      deleteReceipt: {
        title: 'Beleg löschen',
        successToast: 'Der Beleg wurde erfolgreich gelöscht',
      },
      partialRefund: {
        title: 'Hinweis',
      },
      addReceiptFlow: {
        confirmClose: {
          title: 'Bist Du sicher?',
          cancelButtonTitle: 'Nein',
          okButtonTitle: 'Ja',
          message: 'Dein bisheriger Fortschritt wird permanent verworfen',
        },
        addReceiptSummary: 'Zusammenfassung',
        createReceiptSuccess: 'Beleg wurde eingereicht',
      },
      periodCloseDelayWarning_one:
        'Dein Arbeitgeber benötigt alle Belege bis {{count}} Tag vor Monatsende, ein Upload ist danach nicht mehr möglich',
      periodCloseDelayWarning_other:
        'Dein Arbeitgeber benötigt alle Belege bis {{count}} Tage vor Monatsende, ein Upload ist danach nicht mehr möglich',
    };
  }
}
